import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    welcome: "Welcome to HIBISAAS",
    table: "Table",
    menu: "Menu",
    cart: "Cart",
    checkout: "Checkout",
    order_placed: "Order Placed",
    preparing: "Preparing",
    ready: "Ready",
    served: "Served",
    pay_now: "Pay Now",
    split_bill: "Split Bill",
    add_to_cart: "Add",
    view_cart: "View Cart",
    total: "Total",
    takeaway: "Take Something Home?",
    thank_you: "Thank You!",
    leave_review: "Leave us a review",
    place_order: "Place Order",
    your_order: "Your Order",
    items: "items",
    empty_cart: "Your cart is empty",
    browse_menu: "Browse our menu and add items",
    subtotal: "Subtotal",
    remaining: "Remaining",
    paid: "Paid",
    pay_full: "Pay Full Amount",
    pay_selected: "Pay Selected Items",
    select_items: "Select items you want to pay for",
    order_status: "Order Status",
    received: "Received",
    admin: "Admin Dashboard",
    login: "Login",
    password: "Password",
    tables: "Tables",
    orders: "Orders",
    payments: "Payments",
    generate_qr: "Generate QR",
    close_bill: "Close Bill",
    update_status: "Update Status",
    categories: {
      all: "All",
      starters: "Starters",
      mains: "Main Dishes",
      fast_food: "Fast Food",
      gratins_salads: "Gratins & Salads",
      cocktails: "Cocktails",
      soft_drinks: "Soft Drinks",
      beers: "Beers",
      shakes: "Shakes",
      desserts: "Desserts",
      sides: "Sides",
      thai_food: "Thai Food",
      takeaway: "Takeaway",
      breakfast: "Breakfast",
      dark_kitchen: "Dark Kitchen"
    },
    allergens: {
      fish: "Contains Fish",
      gluten: "Contains Gluten",
      dairy: "Contains Dairy",
      eggs: "Contains Eggs"
    },
    tags: {
      vegan: "Vegan",
      spicy: "Spicy",
      gluten_free: "Gluten-Free"
    },
    popular: "Popular",
    payment_success: "Payment Successful!",
    redirecting: "Redirecting to review page..."
  },
  th: {
    welcome: "ยินดีต้อนรับสู่ร้านอาหารของเรา",
    table: "โต๊ะ",
    menu: "เมนู",
    cart: "ตะกร้า",
    checkout: "ชำระเงิน",
    order_placed: "สั่งซื้อแล้ว",
    preparing: "กำลังเตรียม",
    ready: "พร้อมเสิร์ฟ",
    served: "เสิร์ฟแล้ว",
    pay_now: "ชำระเงินตอนนี้",
    split_bill: "แบ่งบิล",
    add_to_cart: "เพิ่มลงตะกร้า",
    view_cart: "ดูตะกร้า",
    total: "รวม",
    takeaway: "นำกลับบ้านไหม?",
    thank_you: "ขอบคุณ!",
    leave_review: "รีวิวร้านเรา",
    place_order: "สั่งอาหาร",
    your_order: "ออเดอร์ของคุณ",
    items: "รายการ",
    empty_cart: "ตะกร้าว่างเปล่า",
    browse_menu: "เลือกอาหารจากเมนู",
    subtotal: "ยอดรวม",
    remaining: "คงเหลือ",
    paid: "ชำระแล้ว",
    pay_full: "ชำระเต็มจำนวน",
    pay_selected: "ชำระรายการที่เลือก",
    select_items: "เลือกรายการที่ต้องการชำระ",
    order_status: "สถานะออเดอร์",
    received: "รับออเดอร์แล้ว",
    admin: "แดชบอร์ดผู้ดูแล",
    login: "เข้าสู่ระบบ",
    password: "รหัสผ่าน",
    tables: "โต๊ะ",
    orders: "ออเดอร์",
    payments: "การชำระเงิน",
    generate_qr: "สร้าง QR",
    close_bill: "ปิดบิล",
    update_status: "อัพเดทสถานะ",
    categories: {
      all: "ทั้งหมด",
      starters: "อาหารเรียกน้ำย่อย",
      mains: "อาหารจานหลัก",
      fast_food: "ฟาสต์ฟู้ด",
      gratins_salads: "กราแตง & สลัด",
      cocktails: "ค็อกเทล",
      soft_drinks: "น้ำอัดลม",
      beers: "เบียร์",
      shakes: "เชค",
      desserts: "ของหวาน",
      sides: "เครื่องเคียง",
      thai_food: "อาหารไทย",
      takeaway: "นำกลับบ้าน",
      breakfast: "อาหารเช้า",
      dark_kitchen: "ดาร์คคิทเช่น"
    },
    allergens: {
      fish: "มีส่วนผสมของปลา",
      gluten: "มีกลูเตน",
      dairy: "มีนม",
      eggs: "มีไข่"
    },
    tags: {
      vegan: "วีแกน",
      spicy: "เผ็ด",
      gluten_free: "ไร้กลูเตน"
    },
    popular: "ยอดนิยม",
    payment_success: "ชำระเงินสำเร็จ!",
    redirecting: "กำลังเปลี่ยนไปหน้ารีวิว..."
  },
  ru: {
    welcome: "Добро пожаловать в наш ресторан",
    table: "Стол",
    menu: "Меню",
    cart: "Корзина",
    checkout: "Оформить",
    order_placed: "Заказ принят",
    preparing: "Готовится",
    ready: "Готов",
    served: "Подан",
    pay_now: "Оплатить",
    split_bill: "Разделить счёт",
    add_to_cart: "В корзину",
    view_cart: "Корзина",
    total: "Итого",
    takeaway: "Возьмёте с собой?",
    thank_you: "Спасибо!",
    leave_review: "Оставьте отзыв",
    place_order: "Оформить заказ",
    your_order: "Ваш заказ",
    items: "позиций",
    empty_cart: "Корзина пуста",
    browse_menu: "Выберите блюда из меню",
    subtotal: "Подитог",
    remaining: "Остаток",
    paid: "Оплачено",
    pay_full: "Оплатить полностью",
    pay_selected: "Оплатить выбранное",
    select_items: "Выберите позиции для оплаты",
    order_status: "Статус заказа",
    received: "Принят",
    admin: "Панель управления",
    login: "Вход",
    password: "Пароль",
    tables: "Столы",
    orders: "Заказы",
    payments: "Платежи",
    generate_qr: "Создать QR",
    close_bill: "Закрыть счёт",
    update_status: "Обновить статус",
    categories: {
      all: "Все",
      starters: "Закуски",
      mains: "Основные",
      drinks: "Напитки",
      desserts: "Десерты",
      takeaway: "На вынос"
    },
    allergens: {
      fish: "Содержит рыбу",
      gluten: "Содержит глютен",
      dairy: "Содержит молоко",
      eggs: "Содержит яйца"
    },
    tags: {
      vegan: "Веган",
      spicy: "Острое",
      gluten_free: "Без глютена"
    },
    popular: "Популярное",
    payment_success: "Оплата успешна!",
    redirecting: "Переход на страницу отзывов..."
  },
  fr: {
    welcome: "Bienvenue dans notre restaurant",
    table: "Table",
    menu: "Menu",
    cart: "Panier",
    checkout: "Paiement",
    order_placed: "Commande passée",
    preparing: "En préparation",
    ready: "Prêt",
    served: "Servi",
    pay_now: "Payer",
    split_bill: "Partager l'addition",
    add_to_cart: "Ajouter",
    view_cart: "Voir panier",
    total: "Total",
    takeaway: "À emporter?",
    thank_you: "Merci!",
    leave_review: "Laissez un avis",
    place_order: "Commander",
    your_order: "Votre commande",
    items: "articles",
    empty_cart: "Panier vide",
    browse_menu: "Parcourez notre menu",
    subtotal: "Sous-total",
    remaining: "Restant",
    paid: "Payé",
    pay_full: "Payer tout",
    pay_selected: "Payer sélection",
    select_items: "Sélectionnez les articles à payer",
    order_status: "Statut commande",
    received: "Reçue",
    admin: "Tableau de bord",
    login: "Connexion",
    password: "Mot de passe",
    tables: "Tables",
    orders: "Commandes",
    payments: "Paiements",
    generate_qr: "Générer QR",
    close_bill: "Clôturer",
    update_status: "Mettre à jour",
    categories: {
      all: "Tout",
      starters: "Entrées",
      mains: "Plats",
      drinks: "Boissons",
      desserts: "Desserts",
      takeaway: "À emporter"
    },
    allergens: {
      fish: "Contient du poisson",
      gluten: "Contient du gluten",
      dairy: "Contient des produits laitiers",
      eggs: "Contient des œufs"
    },
    tags: {
      vegan: "Végan",
      spicy: "Épicé",
      gluten_free: "Sans gluten"
    },
    popular: "Populaire",
    payment_success: "Paiement réussi!",
    redirecting: "Redirection vers la page d'avis..."
  },
  de: {
    welcome: "Willkommen in unserem Restaurant",
    table: "Tisch",
    menu: "Speisekarte",
    cart: "Warenkorb",
    checkout: "Kasse",
    order_placed: "Bestellt",
    preparing: "In Zubereitung",
    ready: "Fertig",
    served: "Serviert",
    pay_now: "Bezahlen",
    split_bill: "Rechnung teilen",
    add_to_cart: "Hinzufügen",
    view_cart: "Warenkorb",
    total: "Gesamt",
    takeaway: "Zum Mitnehmen?",
    thank_you: "Danke!",
    leave_review: "Bewerten Sie uns",
    place_order: "Bestellen",
    your_order: "Ihre Bestellung",
    items: "Artikel",
    empty_cart: "Warenkorb leer",
    browse_menu: "Durchsuchen Sie unser Menü",
    subtotal: "Zwischensumme",
    remaining: "Verbleibend",
    paid: "Bezahlt",
    pay_full: "Alles bezahlen",
    pay_selected: "Auswahl bezahlen",
    select_items: "Wählen Sie Artikel zum Bezahlen",
    order_status: "Bestellstatus",
    received: "Erhalten",
    admin: "Dashboard",
    login: "Anmelden",
    password: "Passwort",
    tables: "Tische",
    orders: "Bestellungen",
    payments: "Zahlungen",
    generate_qr: "QR erstellen",
    close_bill: "Rechnung schließen",
    update_status: "Status aktualisieren",
    categories: {
      all: "Alle",
      starters: "Vorspeisen",
      mains: "Hauptgerichte",
      drinks: "Getränke",
      desserts: "Desserts",
      takeaway: "Mitnehmen"
    },
    allergens: {
      fish: "Enthält Fisch",
      gluten: "Enthält Gluten",
      dairy: "Enthält Milch",
      eggs: "Enthält Eier"
    },
    tags: {
      vegan: "Vegan",
      spicy: "Scharf",
      gluten_free: "Glutenfrei"
    },
    popular: "Beliebt",
    payment_success: "Zahlung erfolgreich!",
    redirecting: "Weiterleitung zur Bewertungsseite..."
  },
  es: {
    welcome: "Bienvenido a nuestro restaurante",
    table: "Mesa",
    menu: "Menú",
    cart: "Carrito",
    checkout: "Pagar",
    order_placed: "Pedido realizado",
    preparing: "Preparando",
    ready: "Listo",
    served: "Servido",
    pay_now: "Pagar ahora",
    split_bill: "Dividir cuenta",
    add_to_cart: "Añadir",
    view_cart: "Ver carrito",
    total: "Total",
    takeaway: "¿Para llevar?",
    thank_you: "¡Gracias!",
    leave_review: "Déjanos una reseña",
    place_order: "Hacer pedido",
    your_order: "Tu pedido",
    items: "artículos",
    empty_cart: "Carrito vacío",
    browse_menu: "Explora nuestro menú",
    subtotal: "Subtotal",
    remaining: "Restante",
    paid: "Pagado",
    pay_full: "Pagar todo",
    pay_selected: "Pagar selección",
    select_items: "Selecciona artículos a pagar",
    order_status: "Estado del pedido",
    received: "Recibido",
    admin: "Panel de control",
    login: "Iniciar sesión",
    password: "Contraseña",
    tables: "Mesas",
    orders: "Pedidos",
    payments: "Pagos",
    generate_qr: "Generar QR",
    close_bill: "Cerrar cuenta",
    update_status: "Actualizar estado",
    categories: {
      all: "Todo",
      starters: "Entrantes",
      mains: "Principales",
      drinks: "Bebidas",
      desserts: "Postres",
      takeaway: "Para llevar"
    },
    allergens: {
      fish: "Contiene pescado",
      gluten: "Contiene gluten",
      dairy: "Contiene lácteos",
      eggs: "Contiene huevos"
    },
    tags: {
      vegan: "Vegano",
      spicy: "Picante",
      gluten_free: "Sin gluten"
    },
    popular: "Popular",
    payment_success: "¡Pago exitoso!",
    redirecting: "Redirigiendo a la página de reseñas..."
  },
  ar: {
    welcome: "مرحباً بكم في مطعمنا",
    table: "طاولة",
    menu: "القائمة",
    cart: "السلة",
    checkout: "الدفع",
    order_placed: "تم الطلب",
    preparing: "قيد التحضير",
    ready: "جاهز",
    served: "تم التقديم",
    pay_now: "ادفع الآن",
    split_bill: "تقسيم الفاتورة",
    add_to_cart: "أضف للسلة",
    view_cart: "عرض السلة",
    total: "المجموع",
    takeaway: "هل تريد شيئاً للمنزل؟",
    thank_you: "شكراً!",
    leave_review: "اترك تقييماً",
    place_order: "تأكيد الطلب",
    your_order: "طلبك",
    items: "عناصر",
    empty_cart: "السلة فارغة",
    browse_menu: "تصفح القائمة وأضف العناصر",
    subtotal: "المجموع الفرعي",
    remaining: "المتبقي",
    paid: "مدفوع",
    pay_full: "ادفع كامل المبلغ",
    pay_selected: "ادفع العناصر المحددة",
    select_items: "حدد العناصر التي تريد دفعها",
    order_status: "حالة الطلب",
    received: "تم الاستلام",
    admin: "لوحة التحكم",
    login: "تسجيل الدخول",
    password: "كلمة المرور",
    tables: "الطاولات",
    orders: "الطلبات",
    payments: "المدفوعات",
    generate_qr: "إنشاء QR",
    close_bill: "إغلاق الفاتورة",
    update_status: "تحديث الحالة",
    categories: {
      all: "الكل",
      starters: "المقبلات",
      mains: "الأطباق الرئيسية",
      drinks: "المشروبات",
      desserts: "الحلويات",
      takeaway: "للأخذ"
    },
    allergens: {
      fish: "يحتوي على سمك",
      gluten: "يحتوي على غلوتين",
      dairy: "يحتوي على حليب",
      eggs: "يحتوي على بيض"
    },
    tags: {
      vegan: "نباتي",
      spicy: "حار",
      gluten_free: "خالي من الغلوتين"
    },
    popular: "شائع",
    payment_success: "تم الدفع بنجاح!",
    redirecting: "جاري التحويل إلى صفحة التقييم..."
  },
  zh: {
    welcome: "欢迎光临",
    table: "桌号",
    menu: "菜单",
    cart: "购物车",
    checkout: "结账",
    order_placed: "已下单",
    preparing: "准备中",
    ready: "可取餐",
    served: "已上菜",
    pay_now: "立即支付",
    split_bill: "分账",
    add_to_cart: "加入购物车",
    view_cart: "查看购物车",
    total: "总计",
    takeaway: "带点回家？",
    thank_you: "谢谢！",
    leave_review: "请留下评价",
    place_order: "下单",
    your_order: "您的订单",
    items: "件商品",
    empty_cart: "购物车是空的",
    browse_menu: "浏览菜单添加商品",
    subtotal: "小计",
    remaining: "剩余",
    paid: "已付",
    pay_full: "全额支付",
    pay_selected: "支付选中项",
    select_items: "选择要支付的项目",
    order_status: "订单状态",
    received: "已接单",
    admin: "管理面板",
    login: "登录",
    password: "密码",
    tables: "餐桌",
    orders: "订单",
    payments: "付款",
    generate_qr: "生成二维码",
    close_bill: "结清账单",
    update_status: "更新状态",
    categories: {
      all: "全部",
      starters: "前菜",
      mains: "主菜",
      drinks: "饮料",
      desserts: "甜点",
      takeaway: "外带"
    },
    allergens: {
      fish: "含鱼",
      gluten: "含麸质",
      dairy: "含乳制品",
      eggs: "含蛋"
    },
    tags: {
      vegan: "纯素",
      spicy: "辣",
      gluten_free: "无麸质"
    },
    popular: "热门",
    payment_success: "支付成功！",
    redirecting: "正在跳转到评价页面..."
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'en';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    // Set RTL for Arabic
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || translations['en'][keys[keys.length - 1]] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, translations: translations[language] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'th', name: 'ไทย', flag: '🇹🇭' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'zh', name: '中文', flag: '🇨🇳' }
];
